namespace $ { $mol_style_attach( "mol/code/code.view.css",
 "[mol_code] {\n\tdisplay: inline-flex;\n\tflex: 1 1 8rem;\n}\n\n[mol_code_manual] {\n\tflex: 1 1 auto;\n}\n"
) }